import { Link } from "react-router-dom";
import { contactDetails } from "@/mocks/products";

function CtaSection() {
  return (
    <section className="w-full bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-8 items-center">
          <div>
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-background-50">
              Sonderausführungen oder nicht abgebildete Drückerverbindungen?
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed max-w-2xl">
              Senden Sie uns Ihr Muster oder Ihre Zeichnung – wir prüfen die Machbarkeit und melden
              uns mit einem konkreten Angebot. Fertigungslose ab 300 Stück.
            </p>
          </div>
          <div className="flex flex-col gap-3 lg:items-end">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-600 text-background-50 font-label text-sm uppercase tracking-wide whitespace-nowrap hover:bg-primary-500 transition-colors"
            >
              <i className="ri-mail-send-line text-base" aria-hidden="true" />
              Anfrage stellen
            </Link>
            <a
              href={contactDetails.phoneHref}
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-background-50/30 text-background-50 font-label text-sm uppercase tracking-wide whitespace-nowrap hover:bg-background-50/10 transition-colors"
            >
              <i className="ri-phone-line text-base" aria-hidden="true" />
              {contactDetails.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaSection;